import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "@/store/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import AppRouter from "./router/AppRouter";
import mixpanel from "mixpanel-browser";

const queryClient = new QueryClient();

const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN || "";
if (import.meta.env.MODE === "uat" && mixpanelToken) {
  mixpanel.init(mixpanelToken, {
    debug: true,
    autocapture: true,
    track_pageview: true,
    persistence: "localStorage",
    record_sessions_percent: 100,
    record_heatmap_data: true,
  });
}

const App = () => (
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <AppRouter />
      </QueryClientProvider>
    </PersistGate>
  </Provider>
);

export default App;
